import {
  Button,
  Menu,
  MenuItem,
  Tabs,
  TabPane,
  Select,
  Option,
  Table,
  TableColumn,
  DatePicker,
  Pagination,
  Switch,
  Slider,
  Tooltip,
  Input,
  Col,
  Row,
  Card,
  Form,
  FormItem,
  Loading,
  Checkbox,
  Dialog,
  Radio,
  Popover,
  InputNumber,
  Progress,
  Breadcrumb,
  BreadcrumbItem,
  badge,
  tree,
  collapse,
  collapseItem,
  dropdown,
  dropdownMenu,
  dropdownItem,
  checkboxGroup,
  upload
} from 'element-ui'

function importElement (Vue) {
  Vue.use(Button)
  Vue.use(Menu)
  Vue.use(MenuItem)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Option)
  Vue.use(Select)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(DatePicker)
  Vue.use(Pagination)
  Vue.use(Switch)
  Vue.use(Slider)
  Vue.use(Tooltip)
  Vue.use(Input)
  Vue.use(Col)
  Vue.use(Row)
  Vue.use(Card)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Loading)
  Vue.use(Checkbox)
  Vue.use(Dialog)
  Vue.use(Radio)
  Vue.use(Popover)
  Vue.use(InputNumber)
  Vue.use(Progress)
  Vue.use(Breadcrumb)
  Vue.use(BreadcrumbItem)
  Vue.use(badge)
  Vue.use(tree)
  Vue.use(collapse)
  Vue.use(collapseItem)
  Vue.use(dropdown)
  Vue.use(dropdownMenu)
  Vue.use(dropdownItem)
  Vue.use(checkboxGroup)
  Vue.use(upload)
}

export default importElement



// WEBPACK FOOTER //
// ./src/js/importElement.js